export enum reduxTypes {
  CAMPUS_UPDATE = 'CAMPUS_UPDATE',
  HIDDEN_FORM_PARAMS_MERGE = 'HIDDEN_FORM_PARAMS_MERGE',
  FEATURE_FLAG_UPDATE = 'FEATURE_FLAG_UPDATE',
  FORM_REDIRECT_UPDATE = 'FORM_REDIRECT_UPDATE',
  LEADSOURCE2_APPEND = 'LEADSOURCE2_APPEND',
  LEADSOURCE2_SET = 'LEADSOURCE2_SET',
  PERSONA_UPDATE = 'PERSONA_UPDATE',
  PROGRAM_UPDATE = 'PROGRAM_UPDATE'
}

export type ReduxAction<Type> = {
  type: reduxTypes,
  payload: Type,
}

export type FeatureFlagStore = {
  newConfirmationPage?: boolean
}
